// extracted by mini-css-extract-plugin
export var header = "_gd-0";